import { defineStore } from 'pinia'
import invitationServices from '@/api/services/invitationServices'
import { useAuthStore } from '@/stores/authStore'
import { ref } from 'vue'

export const useInvitationsStore = defineStore('invitationsStore', () => {
  const invitations = ref([])
  const invitationsCount = ref(null)

  const getInvitations = async () => {
    const authStore = useAuthStore()
    const token = authStore.authData.token

    const { data } = await invitationServices.getInvitations(token)
    invitations.value = data.invitations
  }

  const getInvitationsCount = async () => {
    const authStore = useAuthStore()
    const token = authStore.authData.token

    const { data } = await invitationServices.getInvitationsCount(token)
    invitationsCount.value = data.invitations.length
  }

  const rejectInvitation = async (id) => {
    const authStore = useAuthStore()
    const token = authStore.authData.token

    await invitationServices.rejectInvitation(id, token)
    await getInvitations(token)
  }

  const acceptInvitation = async (id) => {
    const authStore = useAuthStore()
    const token = authStore.authData.token

    await invitationServices.acceptInvitation(id, token)
    await getInvitations(token)
  }

  return {
    invitations,
    invitationsCount,
    getInvitations,
    getInvitationsCount,
    rejectInvitation,
    acceptInvitation
  }
})
